/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright © 2026 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
* patent applications, and are protected by trade secret or copyright law.
* Dissemination of this information, reproduction of this material, and copying or distribution of this software
* is strictly forbidden unless prior written permission is obtained
* from Pearson Education, Inc.
*/

/**
 * Root provider: Harness FME (OpenFeature + Split) unless integrated MLM launch omits it.
 *
 * @file FeatureFlagsProvider.jsx
 * @author Mohamed yasar arabath M
 */

import React from 'react';
import PropTypes from 'prop-types';
import CommonUtils from '../utils/CommonUtils';
import initializeHarnessOpenFeature from './initializeHarnessOpenFeature';
import AppOpenFeatureWrapper from './AppOpenFeatureWrapper';

function IntegratedMlmNoOpProvider({ children }) {
  return <>{children}</>;
}

IntegratedMlmNoOpProvider.propTypes = {
  children: PropTypes.node.isRequired
};

const FeatureFlagsProvider = async () => {
  if (CommonUtils.isIntergratedMLMLaunch()) {
    return IntegratedMlmNoOpProvider;
  }
  await initializeHarnessOpenFeature();

  return AppOpenFeatureWrapper;
};

export default FeatureFlagsProvider;
